import { render, staticRenderFns } from "./CompanyAccordion.vue?vue&type=template&id=16f86d49&scoped=true&"
import script from "./CompanyAccordion.vue?vue&type=script&lang=js&"
export * from "./CompanyAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAccordion.vue?vue&type=style&index=0&id=16f86d49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f86d49",
  null
  
)

export default component.exports